// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3uPLV","DesktopOnly":"Toolbar_DesktopOnly__1hb0I"};